import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    countries: [],
  },
  getters: {
    countries: (state) => state.countries,
  },
  mutations: {
    setCountries: (state, data) => {
      state.countries = data;
    },
  },
  actions: {
    getCountries: async ({ commit, dispatch }) => {
      try {
        const response = await api({ requiresAuth: true }).get("/v1/countries");
        const { data } = response.data;
        commit("setCountries", data);
      } catch (err) {
        dispatch("showToast", {
          type: "error",
          message: err.response?.data?.message || t("messages.somethingWentWrong")
        });
      }
    },
  },
};
